import { jsx as _jsx } from "react/jsx-runtime";
import { TableRow } from '@mui/material';
import styled from 'styled-components';
export const StyledStickyHeaderRow = styled(TableRow) `
  th {
    z-index: 1;
    border: 0;
  }
  &&:last-of-type {
    th {
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
  }

  &&:first-of-type {
    &&:after {
      border-bottom: none;
    }
  }
`;
const StickyHeaderRow = ({ children }) => (_jsx(StyledStickyHeaderRow, { children: children }));
export default StickyHeaderRow;
